import { render, staticRenderFns } from "./DashboardLegacy.vue?vue&type=template&id=1a43254d"
import script from "./DashboardLegacy.vue?vue&type=script&lang=js"
export * from "./DashboardLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports